
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020",
      function () {
        return require("private-next-pages/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020"])
      });
    }
  